import React, { useState } from "react";
import useLeadAutoList from "../useLeadAutoList";
import useLeadAutoFilters from "./useLeadAutoFilters";
import { countActiveFilters } from "./leadAutoFilterTokens";
import LeadAutoQuickFilterBar from "./LeadAutoQuickFilterBar";
import LeadAutoActiveFiltersSummary from "./LeadAutoActiveFiltersSummary";
import LeadAutoAdvancedFiltersPanel from "./LeadAutoAdvancedFiltersPanel";
// Design system `.lf-*` de la cartouche entreprise, déjà scopé sous `.lf`.
import "../../LeadListPage/LeadListFilters/leadFilters.css";

// Cartouche de filtres des leads auto (PER-2410) : barre repliée + vues
// rapides, ligne de résumé des filtres actifs, tiroir avancé.
const LeadAutoListFilters = () => {
  const {
    actions: listActions,
    isLoading,
    nbLead,
    isExportingAll,
    exportProgress,
  } = useLeadAutoList();
  const { leadAutoFilters } = useLeadAutoFilters();
  const [showAdvanced, setShowAdvanced] = useState(false);

  const activeFilterCount = countActiveFilters(leadAutoFilters);

  const onSubmitSearch = (e) => {
    e.preventDefault();
    listActions.onFetchLeadAutoList(leadAutoFilters);
  };

  const exportDisabled = isExportingAll || isLoading || nbLead === 0;
  const exportLabel = isExportingAll
    ? `Export en cours… ${exportProgress.current}/${exportProgress.total}`
    : "Exporter tout (JSON)";

  return (
    <form onSubmit={onSubmitSearch} className="lf mb-3">
      <LeadAutoQuickFilterBar
        showAdvanced={showAdvanced}
        onToggleAdvanced={() => setShowAdvanced((v) => !v)}
        activeFilterCount={activeFilterCount}
        isLoading={isLoading}
      />

      <LeadAutoActiveFiltersSummary />

      {showAdvanced && (
        <LeadAutoAdvancedFiltersPanel
          onClose={() => setShowAdvanced(false)}
          onExport={listActions.handleExportAllJSON}
          isExporting={exportDisabled}
          isLoading={isLoading}
        />
      )}

      {!showAdvanced && (
        <div className="lf-presets" style={{ marginTop: 8 }}>
          <button
            type="button"
            className="lf-link"
            style={{
              border: 0,
              background: "transparent",
              font: "inherit",
              fontSize: 12.5,
              fontWeight: 600,
              color: "var(--lf-ink-3)",
              cursor: exportDisabled ? "not-allowed" : "pointer",
              opacity: exportDisabled ? 0.5 : 1,
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
            }}
            onClick={listActions.handleExportAllJSON}
            disabled={exportDisabled}
            title="Exporter tous les leads (toutes pages) en JSON"
          >
            <i className="fa fa-download" />
            {exportLabel}
          </button>
        </div>
      )}

      <div
        className="text-center mt-2"
        style={{ fontSize: 14, color: "#6c757d" }}
        aria-live="polite"
      >
        <strong>{nbLead}</strong> lead{nbLead > 1 ? "s" : ""} trouvé
        {nbLead > 1 ? "s" : ""}
      </div>
    </form>
  );
};

export default LeadAutoListFilters;
